import { useDatasetContext } from '../../hooks/context/useDatasetContext';
import SlaveTabs from '../../components/Manager/SlaveTabs/SlaveTabs';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import useRoutes from '../../hooks/useRoutes';
import { getSubsetAndItemParams } from '../../utils/getSubsetAndItemParams';
import { GlobalLocationStateType, GridRow, MatchMode } from '../../types/types';
import { GridColumn } from '../../components/Manager/Grid/types';

interface SubsetDatasetProps {
  row: GridRow;
  openFullscreenReference: (
    column: GridColumn,
    value: string | null,
    matchMode: MatchMode,
    label: string,
    datasetId: string,
    // resolvedFilter forwarded from ReferenceInput's click-time JSONata pass.
    // null sentinel = resolved to nothing (strip raw filter).
    resolvedFilter?: Record<string, any> | null
  ) => void;
}

const SubsetDataset = ({
  row,
  openFullscreenReference,
}: SubsetDatasetProps) => {
  const {
    dataset,
    horizontalScroll,
    slaveTabIndex,
    slaveDatasets,
    slaveLazyStates,
    referenceDatasets,
    slaveFilters,
    setSlaveDatasets,
    setSlaveTabIndex,
    setReferenceDatasets,
    setSlaveLazyStates,
    setSlaveFilters,
  } = useDatasetContext();

  const { pathname } = useLocation<GlobalLocationStateType>();
  const history = useHistory();
  const routes = useRoutes();

  const detailColumns = useMemo(
    () =>
      dataset?.items?.filter((column) =>
        dataset.idItem
          ? column.detailVisible !== false
          : column.visible !== false
      ),
    [dataset]
  );

  const openSlaveFilter = (subsetId: string) => {
    const { itemId } = getSubsetAndItemParams(pathname);

    if (itemId) {
      history.push(
        routes.subsetDetailSlaveFilter(dataset?.datasetId, itemId, subsetId),
        { fromPathname: pathname }
      );
    }
  };

  return (
    <SlaveTabs
      masterDataset={dataset}
      parentRow={row}
      isDetail={false}
      tableScrollLeft={horizontalScroll}
      detailColumns={detailColumns}
      slaveTabIndex={slaveTabIndex}
      setSlaveTabIndex={setSlaveTabIndex}
      slaveDatasets={slaveDatasets}
      setSlaveDatasets={setSlaveDatasets}
      setShowSlaveFilter={openSlaveFilter}
      slaveLazyStates={slaveLazyStates}
      slaveFilters={slaveFilters}
      setSlaveFilters={setSlaveFilters}
      referenceDatasets={referenceDatasets}
      setReferenceDatasets={setReferenceDatasets}
      openFullscreenReference={openFullscreenReference}
      setSlaveLazyStates={setSlaveLazyStates}
    />
  );
};

export default SubsetDataset;
